export default {
	TaxPaper: {
		TaxPaper: 'Giấy nộp tiền',
		DbhcCode: 'Mã ĐBHC',
		AddTaxPaper: 'Thêm giấy nộp tiền',
		EditTaxPaper: 'Sửa giấy nộp tiền',
		TaxPaperFiled: 'Giấy nộp tiền nộp thay',
		EditTaxPaperFiled: 'Sửa giấy nộp tiền',
		Widget: 'Chức năng',
		InfoTaxPayer: 'Thông tin người nộp thuế',
		InfoTaxPayerFiled: 'Thông tin người nộp thay',
		TaxCode: 'Mã số thuế/CCCD',
		CompanyName: 'Tên người nộp thuế',
		AuthorizedCompanyName: 'Tên người nộp thay',
		Address: 'Địa chỉ',
		TaxAgentName: 'Cơ quan thuế quản lý',
		Province: 'Tỉnh/Thành phố',
		District: 'Quận/Huyện',
		Ward: 'Phường/Xã',
		InfoMyBank: 'Thông tin ngân hàng',
		InfoTaxAgent: 'Thông tin cơ quan quản lý thu',
		BankSuggest: 'Đề nghị ngân hàng',
		BankOwnerCode: 'Trích tài khoản số',
		TaxAgentNameCollect: 'Cơ quan quản lý thu',
		InfoAddressPay: 'Thông tin nơi phát sinh khoản thu',
		InfoUserIsAuthorized: 'Thông tin người thụ hưởng',
		InfoBankCountry: 'Thông tin kho bạc',
		BankCountryAddressName: 'Chuyển cho Kho bạc nhà nước',
		BankCountryName: 'Mở tại NHTM ủy nhiệm thu',
		SubmissionPurpose: 'Mục đích nộp',
		TaxAgentRule: 'Nộp theo văn bản cơ quan có thẩm quyền',
		TK7111: 'Nộp vào NSNN (TK 7111)',
		TK8993: 'Thu hồi hoàn (TK 8993)',
		TK3397: 'Thu hồi hoàn (TK 3397)',
		InfoDetail: 'Thông tin khoản nộp ngân sách',
		TaxInner: 'Thuế nội địa',
		TaxBefore: 'Thuế trước bạ',
		KindMonney: 'Loại tiền',
		TooltipTaxBefore:
			'Khi nộp Thuế trước bạ, NNT phải ghi thông tin tài sản đăng ký quyền sở hữu, quyền sử dụng tại mục Ghi chú như sau:</br>- Với ô tô, xe máy, tàu, thuyền: Ghi loại xe/tàu/thuyền, nhãn hiệu, số loại, số khung, số máy;</br>- Với nhà đất: Thông tin địa chỉ nhà đất.',
		TooltipInfoPayer:
			'Thông tin tự động lấy theo Thông tin người nộp thuế đã khai báo',
		TooltipCharacterOverload:
			'GNT không được vượt quá giới hạn ký tự theo tiêu chuẩn của Ngân hàng nộp thuế điện tử. Phần mềm đã tự động tính chuẩn ký tự theo yêu cầu của từng Ngân hàng. Nếu GNT vượt quá số ký tự này, vui lòng xóa bớt khoản nộp hoặc sửa lại dòng Ghi chú ngắn gọn hơn.',
		TotalMonney: 'Tổng tiền:',
		TotalCharacter: 'Tổng số ký tự',
		MaxCharacter: '/210',
		TreasuryCode: 'Mã kho bạc',
		TreasuryName: 'Tên kho bạc',
		BankTreasuryCode: 'Mã NHTM',
		BankTreasuryName: 'Tên NHTM',
		DecNo: 'Số tờ khai/Số quyết định/Số thông báo/ Mã định danh hồ sơ (ID)',
		DecNoDecree11: 'Số tờ khai/Số quyết định/Số thông báo',
		DecDate: 'Kỳ thuế/Ngày quyết định/Ngày thông báo',
		ContentPayStateBudger: 'Nội dung khoản nộp NSNN',
		TooltipContentPayStateBudger: 'Nội dung khoản nộp ngân sách nhà nước',
		Note: 'Ghi chú',
		AmountMoney: 'Số tiền VND',
		NaturalCurrent: 'Số tiền nguyên tệ',
		Money: 'Số tiền',
		EconomicCode: 'Mã NDKT',
		TooltipEconomicCode: 'Mã nội dung kinh tế',
		TaxAgencyName: 'Cơ quan QLT',
		TooltipTaxAgencyName: 'Cơ quan quản lý thu',
		ChapterCode: 'Mã chương',
		AlertLimit:
			'GNT vượt số ký tự cho phép. Vui lòng bỏ bớt khoản nộp hoặc sửa lại Ghi chú.',
		Code: 'Mã',
		EconomicCodeBudget: 'Mã tiểu mục',
		EconomicName: 'Tên nội dung kinh tế',
		Name: 'Tên',
		ChapterLevel: 'Cấp quản lý',
		PaperCreatedDate: 'Ngày tạo',
		PaperPaymentCode: 'Số giấy nộp tiền',
		PaperSubmitDate: 'Ngày gửi GNT',
		SubmissionId: 'Mã giao dịch',
		FilingDate: 'Ngày nộp thuế',
		NotiReceivedDateStepOne: 'Ngày tiếp nhận GNT',
		TaxAgencyRejectedDate: 'Ngày TCT từ chối',
		NotiReceivedDateStepTwo: 'Ngày nộp thuế',
		BankRejectedDate: 'Ngày NH từ chối',
		BankPaymentCode: 'Mã CT ngân hàng',
		IsDefault: 'Mặc định cho lần sau',
		TaxCodeIsNotRegis:
			'Mã số thuế chưa đăng ký sử dụng dịch vụ nộp thuế điện tử',
		WaitingChange:
			'Vui lòng đợi cơ quan thuế duyệt tờ khai đăng ký thay đổi/bổ sung trước khi ký nộp GNT',
		WaitingStop:
			'Vui lòng đợi cơ quan thuế duyệt tờ khai đăng ký ngừng dịch vụ trước khi ký nộp GNT',
		WaitingBankChange:
			'Vui lòng đợi cơ quan thuế duyệt tờ khai đăng ký thay đổi/bổ sung ngân hàng trước khi ký nộp GNT',
		WaitingBankStop:
			'Vui lòng đợi cơ quan thuế duyệt tờ khai đăng ký ngừng ngân hàng trước khi ký nộp GNT',
		GIPQueryInfo: 'Truy vấn số thuế phải nộp',
		AlertNoGIP: 'Không có số thuế nào phải nộp',
		AlertNoRegis:
			'Vui lòng đăng ký sử dụng dịch vụ T-VAN MISA mTax để sử dụng tính năng này',
		AlertAtlestOne: 'Vui lòng chọn ít nhất một khoản nộp',
		AlertTypeTax:
			'Mỗi GNT chỉ được lập cho 01 loại thuế gồm Thuế nội địa/Thuế trước bạ',
		AlertAccountType: 'Mỗi GNT chỉ được chọn 01 mục đích nộp',
		AlertTaxAgency: 'Mỗi GNT chỉ nộp cho 01 cơ quan quản lý thu',
		AlertHasTypeOrgAuthority:
			'GNT đã chọn nộp theo văn bản của cơ quan có thẩm quyền',
		AlertNotTypeOrgAuthority:
			'GNT không chọn nộp theo văn bản của cơ quan có thẩm quyền',
		TooltipAccountType: 'Nộp vào tài khoản',
		EconomicCode2801: '2801',
		EconomicCode2802: '2802',
		EconomicCode2803: '2803',
		EconomicCode2804: '2804',
		EconomicCode2824: '2824',
		EconomicCode2825: '2825',
		ErrorDownloadFile: 'Vui lòng chọn định dạng file tải về',
		ErrorChangeTypeMoney:
			'Ngân hàng ủy nhiệm thu chưa cung cấp dịch vụ Nộp thuế điện tử bằng USD',
		ErrorChangeTreasury: 'Kho bạc nhà nước không thu loại tiền USD',
		ErrorChangeTreasuryBank:
			'Ngân hàng ủy nhiệm thu chưa cung cấp dịch vụ Nộp thuế điện tử bằng USD',
		ErrorTreasuryDeactivated:
			'Chuyển cho Kho bạc nhà nước không nằm trong danh sách',
		ErrorTreasuryBankDeactivated:
			'Mở tại NHTM ủy nhiệm thu không nằm trong danh sách',
		IntergrationProcessing:
			'Đang xử lý, vui lòng không tắt trình duyệt và chờ trong ít phút',
		WarningByTaxReturn:
			'Khi bạn nộp thuế từ tờ khai, MISA sẽ lưu lại thông tin Nội dung khoản nộp NSNN và Mã NDKT theo đúng tờ khai bạn đang chọn để gợi ý cho lần nộp tiếp theo. Vui lòng kiểm tra kỹ.',
		ConfirmSignAndSubmitTaxPaper: (nameBank, payerBankCode) =>
			`Khi bạn ký và gửi Giấy nộp tiền, <span class="font-bold">${nameBank}</span> sẽ nhận được lệnh trích tiền và tự động nộp thuế. Bạn có chắc chắn muốn tiếp tục?`,
		ConfirmChangeBankType: (bankName, typeName) =>
			`Việc thay đổi sang ngân hàng <span class="font-bold">${bankName}</span> sẽ thay đổi mẫu Giấy nộp tiền theo <span class="font-bold">${typeName}</span>. Bạn có muốn tiếp tục không?`,
		Circular84: 'Thông tư số 84/2016/TT-BTC',
		Decree11: 'Nghị định số 11/2020/NĐ-CP',
		RecordId: 'Mã định danh hồ sơ (ID)'
	},
	Proceduce: {
		Proceduce: 'Quy trình nộp thuế',
		WatchMovieTutorial: 'Xem phim hướng dẫn',
		RegisterService: 'Đăng ký dịch vụ',
		MakeADeclaration:
			'Lập tờ khai đăng ký sử dụng dịch vụ nộp thuế điện tử qua T-VAN MISA với cơ quan thuế',
		RegisterWithBank: 'Đăng ký với ngân hàng',
		RegisterFromBank:
			'Đăng ký sử dụng dịch vụ nộp thuế điện tử tại Ngân hàng',
		TaxPayment: 'Nộp thuế',
		CompleteProcedure:
			'Hoàn tất thủ tục. Từ giờ bạn có thể bắt đầu nộp thuế điện tử qua MISA mTax.',
		TaxReturnAfter15Min:
			'Cơ quan thuế sẽ duyệt tờ khai đăng ký trong vòng 15 phút',
		ContantBankToSupport:
			'Liên hệ với ngân hàng Nộp thuế điện tử muốn đăng ký để được hỗ trợ',
		ViewGuide: 'Xem hướng dẫn',
		TaxPaymentRegistrationIsInProcessing:
			' "Tờ khai đăng ký thay đổi/bổ sung đang chờ duyệt. Vui lòng thử lại sau khi tờ khai được duyệt xong'
	},
	Column: {
		SelectPayment: 'Chọn khoản nộp',
		ThuTuUuTien: 'Thứ tự thanh toán',
		TenCQThu: 'Cơ quan thu',
		TKNSNN: 'TK nộp NSNN',
		IdKhoanNop: 'ID khoản phải nộp',
		SoQDinhTBao: 'Số tờ khai/ Số quyết định/ Số thông báo',
		KyThue: 'Kỳ thuế/ Ngày quyết định/Ngày thông báo',
		TieuMuc: 'Tiểu mục',
		SoTien: 'Số tiền',
		Chuong: 'Mã chương',
		DBHC: 'ĐBHC',
		HanNop: 'Hạn nộp',
		SoDaNopNHTM: 'Số tiền đã nộp tại NHTM',
		MaTChieuGoc: 'Mã tham chiếu gốc',
		NgayGiaHan: 'Ngày gia hạn',
		TenTrangThai: 'Trạng thái',
		TenTinhChatKhoanNop: 'Tính chất khoản nộp'
	},

	GroupTitle: {
		TaxGroup: 'A. Các khoản thuế, tiền chậm nộp, tiền phạt',
		OtherGroup:
			'B. Các khoản thu khác thuộc NSNN trừ tiền chậm nộp, tiền phạt'
	},
	Alert: {
		OrderPaymentRequired: ids => 
			`<div>Để thực hiện lập GNT này bạn cần hoàn tất nghĩa vụ nộp thuế đối với các khoản phải nộp có thứ tự thanh toán ưu tiên trước (<strong>${ids}</strong>). Bạn vui lòng kiểm tra lại!</div>`,
		PaymentItemIdOrDeNoEmpty: (sttList, isMulti) =>
			`<div>Số tờ khai/Số quyết định/Số thông báo hoặc Mã định danh hồ sơ (ID) ở${isMulti ? ' các' : ''} dòng <strong>${sttList}</strong> không được để trống.</div>`,
		DuplicateDecNoWarningCircular84: mgdList => `<div>Số tờ khai/Số quyết định/Số thông báo/Mã định danh hồ sơ (ID) bạn đang nhập đã tồn tại trên Giấy nộp tiền khác (MGD: <strong>${mgdList}</strong>). <br/>Bạn vui lòng kiểm tra lại để tránh nộp trùng khoản thuế.<br/>Bạn có chắc chắn muốn tiếp tục thực hiện không?</div>`,
		DuplicateDecNoWarningDecree11: mgdList => `<div>Số tờ khai/Số quyết định/Số thông báo và Mã định danh hồ sơ (ID) bạn đang nhập đã tồn tại trên Giấy nộp tiền khác (MGD: <strong>${mgdList}</strong>). <br/>Bạn vui lòng kiểm tra lại để tránh nộp trùng khoản thuế.<br/>Bạn có chắc chắn muốn tiếp tục thực hiện không?</div>`,
		
		// New keys for specific duplicate types
		DuplicatePaymentItemIdOnly: mgdList => 
			`<div>Mã định danh hồ sơ (ID) bạn đang nhập đã tồn tại trên Giấy nộp tiền khác (MGD: <strong>${mgdList}</strong>). <br/>Bạn vui lòng kiểm tra lại để tránh nộp trùng khoản thuế. <br/>Bạn có chắc chắn muốn tiếp tục thực hiện không?</div>`,
		
		DuplicateDecNoOnly: mgdList => 
			`<div>Số tờ khai/Số quyết định/Số thông báo bạn đang nhập đã tồn tại trên Giấy nộp tiền khác (MGD: <strong>${mgdList}</strong>). <br/>Bạn vui lòng kiểm tra lại để tránh nộp trùng khoản thuế. <br/>Bạn có chắc chắn muốn tiếp tục thực hiện không?</div>`,
		
		DuplicateBoth: mgdList =>
			`<div>Số tờ khai/Số quyết định/Số thông báo và Mã định danh hồ sơ (ID) bạn đang nhập đã tồn tại trên Giấy nộp tiền khác (MGD: <strong>${mgdList}</strong>). <br/>Bạn vui lòng kiểm tra lại để tránh nộp trùng khoản thuế. <br/>Bạn có chắc chắn muốn tiếp tục thực hiện không?</div>`,
		
		FieldMismatchWarning: details =>
			`<div>Thông tin trên GNT chưa trùng khớp với dữ liệu truy vấn từ Cơ quan Thuế ${details}Bạn vui lòng kiểm tra lại! </div>`
	}
};
